
(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mar", "april": "Apr", "may": "May", "june": "Jun", "july": "Jul", "august": "Aug", "september": "Sep", "october": "Oct", "november": "Nov", "december": "Dec" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.593"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.593",
    "ar-eg": "static-7.593",
    "bg": "static-7.593",
    "bn": "static-7.593",
    "ca-es": "static-7.593",
    "cs": "static-7.593",
    "da": "static-7.593",
    "de": "static-7.593",
    "el": "static-7.593",
    "en": "static-7.593",
    "es-mx": "static-7.593",
    "es": "static-7.593",
    "fi": "static-7.593",
    "fr": "static-7.593",
    "hr": "static-7.593",
    "hu": "static-7.593",
    "id": "static-7.593",
    "it": "static-7.593",
    "ja": "static-7.593",
    "ko": "static-7.593",
    "nl": "static-7.593",
    "no": "static-7.593",
    "pl": "static-7.593",
    "pt-br": "static-7.593",
    "ro": "static-7.593",
    "ru": "static-7.593",
    "sl": "static-7.593",
    "sv": "static-7.593",
    "th": "static-7.593",
    "tr": "static-7.593",
    "uk": "static-7.593",
    "vi": "static-7.593",
    "zh-cn": "static-7.593",
    "zh-hk": "static-7.593"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.593'}); }
})();


